import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: () => import("../components/HomePage.vue"),
  },
  {
    path: "/biography",
    name: "Biography",
    component: () => import("../components/Biography.vue"),
  },
  {
    path: "/stream",
    name: "Stream",
    component: () => import("../components/Stream.vue"),
  },
];

const router = createRouter({
  history: createWebHistory("/ueda-amu-official/"),
  routes,
});

export default router;
